import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Row } from "../../components/Component";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../hooks/useLogout";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { pharmacyDashboardOrdersAPI, updateOrderStatusAPI } from "../../api/pahrmacy";

const AllOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      topProductLoading: true,
      tableLoading: true,
      orderData: [],
      salesData: [],
      orders: [],
      customerData: [],
      storeStats: [],
      topProducts: [],
      limit: 4,

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [onSearch, setonSearch] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const orderData = watch("orderData");
  const limit = watch("limit");
  const page = watch("page");
  const tableLoading = watch("tableLoading");
  const id = localStorage.getItem("userId");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(onSearchText);
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [onSearchText]);
  useEffect(() => {
    const body = {
      search: debouncedSearch,
      page: currentPage,
      limit: itemPerPage,
      pharmacyId: id || "",
    };

    getOrders(body);
  }, [debouncedSearch, currentPage, itemPerPage]);
  const getOrders = (body) => {
    pharmacyDashboardOrdersAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("limit", res.data.data?.totalOrders);
          setValue("page", res.data.data?.page);
          setValue("orderData", res.data.data);
          setValue("tableLoading", false);
        } else if (res.data.status === false) {
          setValue("tableLoading", false);
          setValue("cityDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("tableLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("tableLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const onOrderClick = (item) => {
    const body = {
      orderId: item?.id || "",
      userId: item?.userId || "",
    };
    navigate("/order-details", { state: body });
  };
  const updateOrderStatus = (item) => {
    console.log("order", item);
    const payload = {
      orderId: item?.id,
      status: item?.next_status,
    };

    updateOrderStatusAPI(payload)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setIsOpen(false);
          const body = {
            search: debouncedSearch,
            page: currentPage,
            limit: itemPerPage,
            pharmacyId: id || "",
          };

          getOrders(body);
        } else if (res.data.status === false) {
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        // toast.error(err?.response?.data?.message);
      });
  };
  return (
    <>
      <Head title="Orders" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Order List</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={`g-gs`}>
            <Col>
              <RecentOrders
                title={"Orders"}
                setSearchText={setSearchText}
                onSearchText={onSearchText}
                onSearch={onSearch}
                setonSearch={setonSearch}
                data={orderData?.orders}
                getOrders={getOrders}
                limit={limit}
                page={page}
                setItemPerPage={setItemPerPage}
                itemPerPage={itemPerPage}
                paginate={paginate}
                currentPage={currentPage}
                isLoading={tableLoading}
                onOrderClick={onOrderClick}
                pagination
                updateOrderStatus={updateOrderStatus}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                setSelectedRow={setSelectedRow}
                selectedRow={selectedRow}
                setValue={setValue}
                watch={watch}
              />
            </Col>
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default AllOrder;
